import React from 'react'
import {
  Box,
  Button,
  Container,
  Grid,
  GridItem,
  Heading,
  Image,
  Input,
  SimpleGrid,
  Stack,
  Text,
} from '@chakra-ui/react'
import { useColorModeValue } from '../../../components/ui/color-mode'
import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next';



let isIOSDevice = !window.MSStream && /iPad|iPhone|iPod/.test(navigator.userAgent); // fails on iPad iOS 13

const ListHeader = ({children}) => {
  return (
    <Text  fontFamily={'Momo Trust Display'} fontWeight={ isIOSDevice ? 'medium' : 'normal'} fontSize={'lg'} mb={2}>
      {children}
    </Text>
  )
}

export default function Footer({globalColor, footerImage}) {

  const MotionImage = motion.create(Image);
  const footerVector= footerImage || require('../../../assets/vector/6.png') 
  const palette = globalColor || 'purple'
  const {t} = useTranslation()

  return (
  
    <Box 
      px={{ md: 'inherit', '2xl': "1%", base: 4 }}
      py={10}
      pt={{md: 20, base: 10}}
      position={'relative'}
    >
        <Box
        minH={'500px'}
        pos={'relative'}
        //overflow={'hidden'}
        color={'white'}
        //boxShadow={'lg'}
        px={{ md: 'inherit', '2xl': "19%", base: 4 }}
        borderTop="1px solid"
        borderColor={useColorModeValue('gray.100', 'gray.900')}
        rounded={24}
        bgColor={useColorModeValue('gray.900', 'gray.900')}
        boxShadow="0 4px 30px rgba(0, 0, 0, 0.1)" // Une ombre subtile pour un effet 3D
        //border="1px solid rgba(255, 255, 255, 0.3)" // Une bordure semi-transparente pour simuler le bord du verre               
        // Couleur du texte
        >
          <Container as={Stack} maxW={'full'} py={10}>

            <Grid pt={10} 
            borderBottom={'1px solid'}
            borderColor={'gray.800'}
              pb={10}
              gap={{'2xl': 'inherit', base: 5}}
              w={'full'} gridTemplateColumns={{md :'2fr 1fr', base: '1fr'}}>
              <GridItem>
                <Heading 
                  fontFamily={'Poppins'}
                  fontSize={{ '2xl': '4xl', md: '3xl', base: 'xl' }}
                  fontWeight={600}
                  lineHeight={1.1}
                  letterSpacing={-1.8}>
                  {t('footerTitle')}
                </Heading>
              </GridItem>

              <GridItem display={'flex'} flexDir={{md: 'row', base: 'column'}} gap={4}>
                <Input size={{'2xl': 'xl', base: 'md'}} rounded={'full'} placeholder={t('footerSubtitle')} _placeholder={{
                  color: useColorModeValue('gray.400', 'gray.100')
                }}/>
                <Button colorPalette={palette} variant={'surface'} rounded={'full'} size={{'2xl': 'xl', base: 'md'}}>
                  {t('footerCallToAction')}
                </Button>
              </GridItem>
            </Grid>


            <SimpleGrid
              templateColumns={{ md: '1fr 1fr' }}
              spacing={8}>
              <GridItem spacing={6} align={{md: 'inherit', base:'center'}}>
                <Box>
                  <Image src={require('../../../assets/logo.png')} w={{md: '160px', base: '140px'}}  /> 
                </Box>
                <Text fontFamily={'Onest'} maxW={{ md: '400px', base: 'full'}}>
                  {t('footerDescription')}
                </Text>
                <Text mt={6} fontSize={'sm'}>&copy; 2025  All Rights Reserved. </Text>
              </GridItem>
              
              <GridItem pt={10}>
                <SimpleGrid columns={{md: 4, base: 2}} gap={4}>
                  <GridItem display={'flex'} flexDir={'column'} align={'flex-start'}>
                    <ListHeader  textTransform={'uppercase'} fontWeight={600} fontFamily={'M'} fontSize={{ '2xl' :'md', base: 'sm'}}>{t('footerLink.Products.title')}</ListHeader>
                    <Box  as="a" href={'#'} fontSize={'sm'}>
                      {t('footerLink.Products.link1')}
                    </Box>
                    <Box as="a" href={'#'} fontSize={'sm'}>
                      {t('footerLink.Products.link2')}
                    </Box>
                  </GridItem>
                  <GridItem display={'flex'} align={'flex-start'} flexDir={'column'}>
                    <ListHeader textTransform={'uppercase'} fontWeight={600} fontFamily={'M'} fontSize={{ '2xl' :'md', base: 'sm'}}>{t('footerLink.Company.title')}</ListHeader>
                    <Box as="a" href={'#'} fontSize={'sm'}>
                      {t('footerLink.Company.link1')}
                    </Box>
                    <Box as="a" href={'#'} fontSize={'sm'}>
                      {t('footerLink.Company.link2')}
                    </Box>
                  </GridItem>
                  <GridItem display={'flex'} align={'flex-start'} flexDir={'column'}>
                    <ListHeader  textTransform={'uppercase'} fontWeight={600} fontFamily={'M'} fontSize={{ '2xl' :'md', base: 'sm'}}>{t('footerLink.Support.title')}</ListHeader>
                    <Box as="a" href={'#'} fontSize={'sm'}>
                      {t('footerLink.Support.link1')}
                    </Box>
                    <Box as="a" href={'#'} fontSize={'sm'}>
                      {t('footerLink.Support.link2')}
                    </Box>
                  </GridItem>
                  <GridItem display={'flex'} align={'flex-start'} flexDir={'column'}>
                    <ListHeader  textTransform={'uppercase'} fontWeight={600} fontFamily={'M'} fontSize={{ '2xl' :'md', base: 'sm'}}>{t('footerLink.Follow.title')}</ListHeader>
                    <Box as="a" href={'#'} fontSize={'sm'}>
                      {t('footerLink.Follow.link1')}
                    </Box>
                    <Box as="a" href={'#'} fontSize={'sm'}>
                      {t('footerLink.Follow.link2')}
                    </Box>
                  </GridItem>
                </SimpleGrid>

              </GridItem>
            </SimpleGrid>
          </Container>


        {/* <MotionImage
          w={'400px'} opacity={useColorModeValue(0.5, 'none')}  bottom={0} position={'absolute'} right={0} src={require('../../../assets/vector/6.png')}
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: useColorModeValue(0.5, 1), x: 0 }}
          animate={{ y: [0, -20, 0] }}
          transition={{
              duration: 1,
              y: { duration: 6, repeat: Infinity, ease: "easeInOut" }
          }}
        /> */}
        <MotionImage
          w={{ '2xl': '300px', base: '130px'}} 
          transform={'scaleX(-1)'}
          rotate={'35deg'}
          opacity={useColorModeValue( 'none')}  top={{'2xl' :-20, base: -10}} position={'absolute'} left={0} src={footerVector}
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: useColorModeValue(1, 1), x: 0 }}
          animate={{ y: [0, -20, 0] }}
          transition={{
              duration: 1,
              y: { duration: 6, repeat: Infinity, ease: "easeInOut" }
          }}
        />
      </Box>
    </Box>
  )
}


